import { render, staticRenderFns } from "./ReLogin.vue?vue&type=template&id=2ebb9f1d&"
import script from "./ReLogin.vue?vue&type=script&lang=ts&"
export * from "./ReLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports